import route from '@/router/index'
import {AUTHORITIES_NAME, USER_NAME, DEVICE_ID} from '@/constant'
import securityCfg from '@/security/config'
import {disConnectSocket} from '@/websocket/index'

const security = (function (router) {
  let userName
  let authorities
  let authorizationMapper
  let authenSuccesUrlRedirect

  let initAuthorities = function () {
    let authoritiesStore = getAuthoritiesStore()
    authorities = new Map()
    for (let element of authoritiesStore) {
      let author = element
      authorities.set(author, author)
    }
  }

  let initAuthorizationMapper = function () {
    authorizationMapper = []
    cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper)
  }

  let initAuthenSuccesUrlRedirect = function () {
    authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor)
  }

  let initConfig = function () {
    initAuthorizationMapper()
    initAuthenSuccesUrlRedirect()
  }

  let initRouteFilter = function () {
    router.beforeEach((to, from, next) => {
      let _isLogin = isLogin()
      let _fullPath = to.fullPath
      let _isAuthorized = isAuthorized(_fullPath)
      if (!_isLogin && _fullPath === '/') {
        next({name: 'Wrapper'})
      } else if (_isLogin && (_fullPath === '/')) {
        next(authenSuccesUrlRedirect)
      } else if (_isAuthorized) {
        next()
      } else if (!_isLogin) {
        next({name: 'Default'})
      } else {
        next({name: 'page403'})
      }
    })
  }

  let cloneObjConfig = function (origin, target) {
    for (let attr in origin) {
      target[attr] = origin[attr]
    }
  }

  let isLogin = function () {
    return authorities && authorities.size
  }

  let hasAuthor = function (author) {
    return authorities.has(author)
  }

  let isAuthorized = function (path) {
    let _isAuthorized = true
    for (let authorCfg of authorizationMapper) {
      if (!(authorCfg.regex instanceof RegExp)) {
        continue
      }
      if (authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === 'function') {
        _isAuthorized &= authorCfg.isAuthorized(hasAuthor)
      }
    }
    return _isAuthorized
  }

  let authLogin = function (authoritiesStore, userName, deviceId) {
    // localStorage.setItem(ACCESS_TOKEN_NAME, access_token)
    localStorage.setItem(AUTHORITIES_NAME, JSON.stringify(authoritiesStore))
    localStorage.setItem(USER_NAME, userName)
    localStorage.setItem(DEVICE_ID, deviceId)
    initAuthorities()
    setupUserInfor()
    // initAuthenSuccesUrlRedirect()
    // route.push(authenSuccesUrlRedirect)
  }

  let authLogout = function () {
    authorities.clear()
    localStorage.clear()
    disConnectSocket()
    route.push({path: '/'}).catch(err => {
    })
  }

  let getAuthoritiesStore = function () {
    let authoritiesStore
    try {
      let _authoritiesStr = localStorage.getItem(AUTHORITIES_NAME)
      if (_authoritiesStr) {
        authoritiesStore = JSON.parse(_authoritiesStr)
      } else {
        authoritiesStore = []
      }
    } catch (e) {
      authoritiesStore = []
    }
    return authoritiesStore
  }

  let getUserName = function () {
    return userName
  }

  let setupUserInfor = function () {
    userName = localStorage.getItem(USER_NAME)
  }

  let init = function () {
    initAuthorities()
    initConfig()
    setupUserInfor()
    initRouteFilter()
  }

  init()

  return {
    roles: securityCfg.roles,
    getUserName: getUserName,
    hasAuthor: hasAuthor,
    isAuthorized: isAuthorized,
    isLogin: isLogin,
    authLogin: authLogin,
    authLogout: authLogout,
  }
})(route)

export function roles() {
  return security.roles
}

export function getUserName() {
  return security.getUserName()
}

export function hasAuthor(author) {
  return security.hasAuthor(author)
}

export function isAuthorized(path) {
  return security.isAuthorized(path)
}

export function authLogin(authoritiesStore, userName, deviceId) {
  return security.authLogin(authoritiesStore, userName, deviceId)
}

export function authLogout() {
  return security.authLogout()
}




// WEBPACK FOOTER //
// ./src/security/index.js